$(function () {
    $(".slider").each(function () {
        var slider = $(this).find('.slider-items');
        slider.slick({
            fade: true,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: slider.closest('.slider').find('.sliderPrevButton'),
            nextArrow: slider.closest('.slider').find('.sliderNextButton')
        });
    })
});